import gql from 'graphql-tag';

export const OrgDefaultClassificationLevelIdQuery = gql`
	query OrgDefaultClassificationLevelIdQuery {
		orgDefaultClassificationLevelId
	}
`;
